
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_40624","data-name":"Group 40624","transform":"translate(-1016 -615)"}},[_c('rect',{attrs:{"id":"Rectangle_7835","data-name":"Rectangle 7835","width":"22","height":"22","rx":"5","transform":"translate(1016 615)","fill":"#f4f5fd"}}),_c('g',{attrs:{"id":"Group_22800","data-name":"Group 22800","transform":"translate(435.657 580.844)"}},[_c('g',{attrs:{"id":"Group_40600","data-name":"Group 40600","fill":"none","stroke-width":"1"}},[_c('line',{attrs:{"id":"Line_1151","data-name":"Line 1151","x2":"14","transform":"translate(583.957 45.502)","stroke":"#5b6473","stroke-linecap":"round"}}),_c('rect',{attrs:{"id":"Rectangle_13077","data-name":"Rectangle 13077","width":"14","height":"4","rx":"1","transform":"translate(583.957 39.303)","stroke":"#c5c8d2"}}),_c('rect',{attrs:{"id":"Rectangle_13078","data-name":"Rectangle 13078","width":"14","height":"4","rx":"1","transform":"translate(583.957 47.701)","stroke":"#c5c8d2"}})])])])])
          )
        }
      }
    